module.exports = __webpack_public_path__ + "static/media/img123.93780ef5.jpg";